import { cn } from "@/lib/utils";

const base = "inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold border whitespace-nowrap";

export function StagePill({ name, isWon, isLost, color, testid }) {
  if (!name) return <span className="text-xs text-slate-400">—</span>;
  if (color) {
    return (
      <span data-testid={testid} className={base} style={{ color, borderColor: color, backgroundColor: color + "1A" }}>
        {name}
      </span>
    );
  }
  const cls = isWon
    ? "bg-emerald-50 text-emerald-700 border-emerald-200"
    : isLost
    ? "bg-rose-50 text-rose-700 border-rose-200"
    : "bg-sky-50 text-sky-700 border-sky-200";
  return <span data-testid={testid} className={cn(base, cls)}>{name}</span>;
}
